import { render, staticRenderFns } from "./NetworkCard.vue?vue&type=template&id=73be90c3&scoped=true&"
import script from "./NetworkCard.vue?vue&type=script&lang=js&"
export * from "./NetworkCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be90c3",
  null
  
)

export default component.exports